import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class ValidateContractOnlyUseCase implements UseCase<Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.contractProvider.validate(contract, false),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
